// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3G5-J","author":"Table_author__3zr7v","authorImage":"Table_authorImage__2ZAue","unreadRow":"Table_unreadRow__1A0xm"};